import * as FormControl from '../../common/utils/form-controls';
import * as CONST from '../utils/constants';
import distances from './max-distance.json';
import states from './state-abbr.json';

const services = [
   {
    Value: 1,
    Name: 'Insurance Agents'
  },
  {
    Value: 2,
    Name: 'Financial Advisors'
  }
];


// global window
const filterObj = CONST.globalProject.SearchFilters;

// initial state
// object name must match specification name
const filters = {
	Zipcode: new FormControl.FilterGroup(
		'Zipcode', '', '', false, true, 'textbox',
		new FormControl.Textbox('Zipcode', 'Zipcode', true), 'filter-search'
	),
	MaxMiles: new FormControl.FilterGroup('MaxMiles', 'Distance', 25, false, true, 'select', distances),
    AgentType: new FormControl.FilterGroup('AgentType', 'Service', 'All Agents & Advisors', false, true, 'select', services),
    Name: new FormControl.FilterGroup(
        'Name', '', '', false, true, 'textbox',
        new FormControl.Textbox('Agent name', 'Name', true), 'filter-search'
    ),
    StateCode: new FormControl.FilterGroup('StateCode', 'State', '', false, true, 'select', states),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };